import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress as HeroCircularProgress } from '@heroui/react';
export const CircularProgress = (props) => {
    return _jsx(HeroCircularProgress, { ...props });
};
export default CircularProgress;
//# sourceMappingURL=CircularProgress.js.map